import React, {lazy, Suspense, memo, useEffect} from 'react'
import {useSelector} from 'react-redux'
import Loading from 'components/shared-components/Loading';
import DeprecationBanner from 'components/shared-components/DeprecationBanner';
import Views from 'views';
import {env} from "../configs/EnvironmentConfig";
import {isMobileApp} from "../configs/AppConfig";

const AppLayout = lazy(() => import('./AppLayout'));
const MobileLayout = lazy(() => import('./MobileLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {

    const token = useSelector(state => state.auth.token);
    const blankLayout = useSelector(state => state.theme.blankLayout);


    useEffect(() => {
        if (env.ENV !== "PROD") {
            document.title = "Kehila - Admin (Dev)"
        }
    }, [])

    let AuthorisedLayout=isMobileApp?MobileLayout:AppLayout
    let Layout = !token ? AuthLayout : AuthorisedLayout

    return (
        <>
            {!blankLayout && <DeprecationBanner/>}
            <Suspense fallback={<Loading cover="content"/>}>
                <Layout>
                    <Views/>
                </Layout>
            </Suspense>
        </>
    )
}

export default memo(Layouts)
